import { render } from "./marquis-circle-icon.svg.vue?vue&type=template&id=75f6eece"
import script from "./marquis-circle-icon.svg.vue?vue&type=script&lang=js"
export * from "./marquis-circle-icon.svg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__